import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.UserActionsToolbar.SyncDropdownContent.ConnectedCompany', {
    buttonSync: 'Sync',
    inProgressStatusText: 'Sync in progress',
    errorStatusText: 'Error',
});
